import { CustomerActionType } from './enums';
import { CustomerState, CustomerAction } from './interfaces';

export const initialState: CustomerState = {
	loading: false,
	error: false,
	leadId: '',
	projectId: '',
	projectName: '',
	leadName: '',
	sessionID: '',
	userDetails: {},
	quotations: [],
	floorPlanDocURL: '',
	predictionId: '',
	uploadedFloorPlanUrls: [],
	predictionStatus: null,
	isPolling: false,
	predictionData: [],
	preDesignQuotation: [],
	preDesignQuotationLoading: false,
	budget: '',
	defaultQuotations: {},
	defaultQuotationsLoading: false,
	floorPlanImages: [],
	selectedQuotation: {},
	selectedQuotationLoading: false,
	quotationsLoading: false,
	productCategories: [],
	productCategoriesLoading: false,
	productCategoriesError: false,
	chatHistory: [],
	chatHistoryLoading: false,
	chatHistoryError: false,
	twoDJson: {},
	twoDJsonLoading: false,
	twoDJsonError: false,
	threeDJson: {},
	threeDJsonLoading: false,
	threeDJsonError: false,
	productCalculationId: ''
};

export default (state = initialState, { type, payload }: CustomerAction): CustomerState => {
	switch (type) {
		case CustomerActionType.UPLOAD_FLOOR_PLAN:
			return {
				...state
			};

		case CustomerActionType.SEND_CUSTOMER_OTP:
		case CustomerActionType.VERIFY_CUSTOMER_OTP:
			return {
				...state,
				loading: true
			};

		case CustomerActionType.SEND_CUSTOMER_OTP_FAILED:
		case CustomerActionType.VERIFY_CUSTOMER_OTP_FAILED:
			return {
				...state,
				loading: false,
				error: true
			};

		case CustomerActionType.SEND_CUSTOMER_OTP_SUCCESS:
			return {
				...state,
				sessionID: payload.session_id,
				leadId: payload.lead_id,
				loading: false
			};

		// case CustomerActionType.SET_QUOTATION_ID:
		// 	return {
		// 		...state,
		// 		quotationId: payload
		// 	};

		case CustomerActionType.SET_PROJECT_DETAILS:
			return {
				...state,
				projectId: payload.projectId,
				projectName: payload.projectName,
				leadName: payload?.leadName ?? state.leadName,
				// floorPlanDocURL: payload?.attachments[0]?.documentUrl,
				budget: payload?.budget
			};

		case CustomerActionType.STORE_PREDICTION_ID:
			return {
				...state,
				predictionId: payload?.id,
				uploadedFloorPlanUrls: payload?.input?.images || [],
				floorPlanDocURL: payload?.input?.images?.[0] || ''
			};

		case CustomerActionType.SET_LEAD_NAME:
			return {
				...state,
				leadName: payload
			};

		case CustomerActionType.FETCH_QUOTATIONS: {
			return {
				...state,
				quotationsLoading: true
			};
		}

		case CustomerActionType.STORE_QUOTATIONS:
			return {
				...state,
				quotationsLoading: false,
				quotations: payload?.quotations
			};

		case CustomerActionType.RESET_QUOTATIONS:
			return {
				...state,
				quotationsLoading: false,
				quotations: []
			};

		// case CustomerActionType.STORE_AREAS:
		// 	return {
		// 		...state,
		// 		predictionStatus: payload?.status,
		// 		areas: payload?.output?.areas
		// 	};

		case CustomerActionType.GET_PREDICTION: {
			return {
				...state,
				predictionStatus: 'pending',
				error: null,
				isPolling: true
			};
		}

		case CustomerActionType.STORE_AREAS: {
			return {
				...state,
				predictionStatus: 'succeeded',
				predictionData: payload?.output?.analysisJson?.areas || payload?.output?.areas || payload?.areas || [],
				isPolling: false
			};
		}

		case CustomerActionType.PREDICTION_FAILED: {
			return {
				...state,
				predictionStatus: 'rejected',
				error: payload.error,
				isPolling: false
			};
		}

		case CustomerActionType.FETCH_CUSTOMER_DETAILS:
			return {
				...state,
				error: false,
				loading: true
			};

		case CustomerActionType.STORE_CUSTOMER_DETAILS:
			return {
				...state,
				error: false,
				loading: false,
				userDetails: payload,
				leadId: payload?.leadId
			};

		case CustomerActionType.ERROR_CUSTOMER_DETAILS:
			return {
				...state,
				error: true,
				loading: false
			};

		case CustomerActionType.GET_PRE_DESIGN_QUOTATION:
			return {
				...state,
				preDesignQuotationLoading: true
			};

		case CustomerActionType.STORE_PRE_DESIGN_QUOTATION:
			return {
				...state,
				preDesignQuotationLoading: false,
				preDesignQuotation: payload?.quotations
			};

		case CustomerActionType.ERROR_PRE_DESIGN_QUOTATION: {
			return {
				...state,
				preDesignQuotationLoading: false,
				preDesignQuotation: payload.error
			};
		}

		case CustomerActionType.GET_DEFAULT_QUOTATION:
			return {
				...state,
				defaultQuotationsLoading: true
			};

		case CustomerActionType.STORE_DEFAULT_QUOTATION:
			return {
				...state,
				defaultQuotations: payload,
				defaultQuotationsLoading: false
			};

		case CustomerActionType.ERROR_DEFAULT_QUOTATION: {
			return {
				...state,
				defaultQuotationsLoading: false,
				defaultQuotations: payload.error
			};
		}

		case CustomerActionType.SET_LEAD_AND_PROJECT_ID:
			return {
				...state,
				leadId: payload?.urlLeadId,
				projectId: payload?.urlProjectId
			};

		case CustomerActionType.SET_LEAD_ID:
			return {
				...state,
				leadId: payload?.urlLeadId
			};

		case CustomerActionType.STORE_FLOOR_PLAN_IMAGES:
			return {
				...state,
				floorPlanImages: payload
			};

		case CustomerActionType.FETCH_QUOTATION_BY_ID:
			return { ...state, selectedQuotation: {}, selectedQuotationLoading: true };
		case CustomerActionType.ERROR_QUOTATION_BY_ID:
			return { ...state, selectedQuotationLoading: false };
		case CustomerActionType.STORE_QUOTATION_BY_ID:
			return {
				...state,
				selectedQuotation: payload,
				selectedQuotationLoading: false
			};

		case CustomerActionType.FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN: {
			return {
				...state,
				productCategories: [],
				productCategoriesLoading: true,
				productCategoriesError: { code: '', message: '', type: '' }
			};
		}

		case CustomerActionType.STORE_PRODUCT_CATEGORIES_FLOOR_PLAN: {
			return {
				...state,
				productCategoriesLoading: false,
				productCategories: payload.areas,
				productCalculationId: payload?.calculationId
			};
		}

		case CustomerActionType.ERROR_FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN: {
			return {
				...state,
				productCategoriesLoading: false,
				productCategoriesError: payload.error
			};
		}

		case CustomerActionType.FETCH_TICKET_CHAT:
			return {
				...state,
				chatHistory: [],
				chatHistoryLoading: true,
				chatHistoryError: false
			};

		case CustomerActionType.STORE_TICKET_CHAT:
			return {
				...state,
				chatHistory: payload.chatHistory,
				chatHistoryLoading: false,
				chatHistoryError: false
			};

		case CustomerActionType.ERROR_FETCH_TICKET_CHAT:
			return {
				...state,
				chatHistoryLoading: false,
				chatHistoryError: true
			};

		case CustomerActionType.FETCH_2D_JSON: {
			return {
				...state,
				twoDJsonLoading: true,
				twoDJson: {}
			};
		}

		case CustomerActionType.STORE_2D_JSON: {
			return {
				...state,
				twoDJsonLoading: false,
				twoDJson: payload
			};
		}

		case CustomerActionType.ERROR_FETCH_2D_JSON: {
			return {
				...state,
				twoDJsonLoading: false,
				twoDJsonError: payload.error
			};
		}

		case CustomerActionType.FETCH_3D_JSON: {
			return {
				...state,
				threeDJsonLoading: true,
				threeDJson: {}
			};
		}

		case CustomerActionType.STORE_3D_JSON: {
			return {
				...state,
				threeDJsonLoading: false,
				threeDJson: payload
			};
		}

		case CustomerActionType.ERROR_FETCH_3D_JSON: {
			return {
				...state,
				threeDJsonLoading: false,
				threeDJsonError: payload.error
			};
		}

		default:
			return state;
	}
};
